import { Injector } from '@angular/core';
import { environment } from '../../environments/environment';

export class AppComponentBase {
    activeDomain: string;
    livetracker: boolean;
    resultModalSportradar: boolean;
    systemName: string;

    constructor(injector: Injector) {
        this.activeDomain = environment.domain;
        this.livetracker = environment.livetracker;
        this.resultModalSportradar = environment.resultModalSportradar;
        this.systemName = environment.systemName;
    }
}
